import { FormErrors } from 'app/shared/validators/generic-validators';
import { MdDialogRef } from '@angular/material';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, ElementRef, OnInit, OnChanges, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';

import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { Document } from 'app/shared/models/document.model';
import { User } from 'app/shared/models/user.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { EntityDocumentsService } from 'app/entities/documents/entity-documents.service';

@Component({
  selector: 'add-document',
  templateUrl: './add-document.component.html',
})


export class AddDocumentComponent implements OnInit, OnChanges {
  public entityId: number;
  private addDocumentForm: FormGroup;
  selectedDocument: Document;
  action: string;
  selectedDocumentType: string;
  documentTypes: ApplicationValue[];
  documentLabels = [];
  users: User[];
  countries = [];
  fileEvent: any;
  fileName: string;
  reUploadfileName: string;
  isServiceDetailsAgrement = false;
  isOutsourcingDetailsAgreement = false;
  isDocumentUpdated = false;
  loginUser: string;


  constructor(
    public dialogRef: MdDialogRef<any>,
    private formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private warmUpService: WarmUpService,
    private cookieService: CookieService,
    private entityDocumentsService: EntityDocumentsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.addDocumentForm = this.formBuilder.group({
      documentDescription: [''],
      documentType: ['', Validators.required],
      docName: [''],
      selectedLabels: [[]],
      startDate: [''],
      endDate: [''],
      passportNumber: [''],
      validFrom: [''],
      validTo: [''],
      issuedBy: [''],
      verifiedBy: [''],
      certifiedBy: ['']
    });

    this.addDocumentForm.get('docName').valueChanges.subscribe(docName => {
      if (this.action === 'Edit') {
        this.addDocumentForm.get('docName').setValidators([Validators.required]);
      }
    });
    this.entityDocumentsService.getDocumentLabels().subscribe(
      response => {
        for (const labelObj of response.arrResult['values']) {
          this.documentLabels.push({ label: labelObj.name, value: { id: labelObj.id, name: labelObj.name } });
        }
        if (this.selectedDocument) {
          const selectedIds = Object.keys(this.selectedDocument.labels);
          const selectedLabels = this.documentLabels.filter(a => {
            for (const id of selectedIds) {
              if (a.value.id == id) {
                return true;
              }
            }
          }).map(a => a.value);
          this.addDocumentForm.patchValue({ selectedLabels: selectedLabels });
        }
      }
    );
    this.users = this.warmUpService.getUsersList();
    this.updateForm();
    this.onValueChanged();
    this.ngOnChanges();
    this.loginUser = this.cookieService.get(ConstantsService.COOKIE_LOGIN_USER_NAME);
    if (this.isServiceDetailsAgrement) {
      const servicesDocument = this.documentTypes.find(document => document.name === 'Service Agreement');
      this.patchSelectedDocType(servicesDocument);
    } else if (this.isOutsourcingDetailsAgreement) {
      const servicesDocument = this.documentTypes.find(document => document.name === 'Outsourcing Agreement');
      this.patchSelectedDocType(servicesDocument);
    }
  }

  patchSelectedDocType(servicesDocument) {
    this.addDocumentForm.patchValue({
      documentType: servicesDocument && servicesDocument.id
    });
    this.selectedDocumentType = servicesDocument && servicesDocument.name;
  }

  onValueChanged(data?: any) {
    if (!this.addDocumentForm) {
      return;
    }
    FormErrors('addDocumentForm', this);
  }

  ngOnChanges() {
    this.loadCategoryTypes(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.DOCUMENT_TYPE));
    this.loadCountries();
  }

  loadCountries() {
    const countries =
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.COUNTRY_TYPE);
    if (countries instanceof Observable) {
      countries.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.countries = response.values;
        }
      );
    } else {
      this.countries = countries;
    }
  }

  loadCategoryTypes(documentTypeValues: any) {
    if (documentTypeValues instanceof Observable) {
      documentTypeValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.documentTypes = response.values;
          this.setDocumentTypeForEditAction();
        }
      );
    } else {
      this.documentTypes = documentTypeValues;
      this.setDocumentTypeForEditAction();
    }
  }

  setDocumentTypeForEditAction() {
    if (this.selectedDocument) {
      const editDocument = this.getSelectedDocument(this.selectedDocument.type);
      if (editDocument) {
        this.selectedDocumentType = editDocument && editDocument.name;
      }
    }
  }

  updateForm(): void {
    if (this.selectedDocument) {
      this.fileName = this.selectedDocument.name;
      const metaData = this.selectedDocument.allMeta;
      this.addDocumentForm.patchValue({
        documentType: this.selectedDocument.type,
        docName: this.selectedDocument.name,
        validFrom: this.selectedDocument.validFrom,
        validTo: this.selectedDocument.validTo,
        passportNumber: metaData && metaData['passportNumber'],
        startDate: metaData && metaData['startDate'],
        endDate: metaData && metaData['endDate'],
        issuedBy: metaData && metaData['issuedBy'],
        certifiedBy: metaData && metaData['certifiedBy'],
        verifiedBy: this.selectedDocument.validatedBy,
        documentDescription: metaData && metaData['otherDetails']
      });
    }
  }

  documentTypeChange(documentId: number) {
    const selectedDocument = this.getSelectedDocument(documentId);
    if (selectedDocument) {
      this.selectedDocumentType = selectedDocument.name;
      this.addDocumentForm.reset();
      if (this.selectedDocument && this.action === 'Edit') {
        this.addDocumentForm.patchValue({
          docName: this.selectedDocument.name,
        });
      }
    }
    this.cdr.detectChanges();
  }

  getSelectedDocument(documentId: number) {
    return this.documentTypes.find(document => document.id === documentId);
  }

  documentFileUploadChange(event) {
    this.fileEvent = event;
    this.fileName = event.target.files[0].name;
    this.reUploadfileName = event.target.files[0].name;
    this.addDocumentForm.patchValue({ docName: this.fileName });
  }

  onSubmit({ value, valid }): void {
    this.isDocumentUpdated = true;
    if (this.action === 'Add') {
      const uploadNewFile = (fileList: FileList) => this.entityDocumentsService.uploadNewDocument(fileList, this.entityId);
      this.uploadFile(value, uploadNewFile);
    } else if (this.action === 'Edit') {
      if (this.reUploadfileName != undefined) {
        const reuploadFileToExistingDocument = (fileList: FileList) => this.entityDocumentsService.updateExistingDocument(fileList, this.selectedDocument.id);
        this.uploadFile(value, reuploadFileToExistingDocument);
      } else {
        this.updateDocumentData([this.selectedDocument.id], value);
      }
    }
  }

  private uploadFile(value, uploadFileLambda: any) {
    const fileList: FileList = this.fileEvent.target.files;
    if (fileList.length > 0) {
      const xhr = uploadFileLambda(fileList);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let documentIds = [];
            if (xhr.response) {
              documentIds = JSON.parse(xhr.response).arrResult;
              if (documentIds.length > 0) {
                this.updateDocumentData(documentIds, value);
              } else {
                this.callSnackBarService(JSON.parse(xhr.response), '');
              }
            } else {
              this.callSnackBarService(JSON.parse(xhr.response), '');
            }
          } else {
            this.callSnackBarService(JSON.parse(xhr.response), '');
          }
        }
      };
    }
  }

  updateDocumentData(documentIds, value) {
    const documents = new Array();
    documentIds.forEach(documentId => {
      const document = new Document();
      document.dateOfUpload = new Date();
      document.entityId = this.entityId;
      document.validFrom = value.validFrom;
      document.validTo = value.validTo;
      document.type = value.documentType;
      document.docOwner = this.selectedDocument && this.selectedDocument.docOwner || this.loginUser;
      if (value.selectedLabels && value.selectedLabels.length > 0) {
        for (const label of value.selectedLabels) {
          document.labels[label.id] = label.name;
        }
      }
      document.id = documentId;
      if (this.action === 'Edit') {
        document.name = value.docName;
      }
      if (this.selectedDocumentType === 'Passport') {
        document.allMeta['passportNumber'] = value.passportNumber;
        document.allMeta['issuedBy'] = value.issuedBy;
        document.allMeta['verifiedBy'] = value.verifiedBy;
        document.allMeta['validFrom'] = value.validFrom;
        document.allMeta['validTo'] = value.validTo;
        document.allMeta['certifiedBy'] = value.certifiedBy;
      } else if (this.selectedDocumentType === 'Indemnity Agreement'
        || this.selectedDocumentType === 'Service Agreement') {
        document.allMeta['startDate'] = value.startDate;
        document.allMeta['endDate'] = value.endDate;
      } else {
        document.allMeta['otherDetails'] = value.documentDescription;
      }
      documents.push(document);
    });
    this.entityDocumentsService.addDocument(documents)
      .subscribe(response => {
        if (!this.isServiceDetailsAgrement && !this.isOutsourcingDetailsAgreement) {
          this.entityDocumentsService.updatedDoucment.emit({
            action: this.action === 'Add' && 'add' || 'edit',
            documents: response.arrResult
          });
        }
        this.callSnackBarService(
          response,
          this.action === 'Add' && MessageService.ADDED_DOCUMENT_SUCCESS || MessageService.UPDATED_DOCUMENT_SUCCESS);
        this.dialogRef.close(response);
      }, err => {
        this.callSnackBarService(err, '');
      });
  }

  callSnackBarService(response: any, successMsg) {
    this.isDocumentUpdated = false;
    this.snackBarService
      .showStatus(response,
      successMsg,
      MessageService.DOCUMENT_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/adddocument/add-document.component.ts